export enum IntroNodeType {
  none = 'NONE',
  url = 'URL',
  liaisonAgent = 'LIAISON_AGENT',
}
